import { render, staticRenderFns } from "./GenerateReturn.vue?vue&type=template&id=2bfaff90&"
import script from "./GenerateReturn.vue?vue&type=script&lang=js&"
export * from "./GenerateReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports